import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Positions from "@/pages/Positions";
import Analytics from "@/pages/Analytics";
import Settings from "@/pages/Settings";
import Signals from "@/pages/Signals";
import Strategy from "@/pages/Strategy";
import Scenario from "@/pages/Scenario";
import Pairs from "@/pages/Pairs";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Vault from "@/pages/Vault";
import SecurityCenter from "@/pages/SecurityCenter";
import Balance from "@/pages/Balance";
import AiAssistant from "@/pages/AiAssistant";
import Landing from "@/pages/Landing";
import Kvkk from "@/pages/Kvkk";
import Sartlar from "@/pages/Sartlar";

// Public root: show Landing for guests, redirect to /dashboard for logged-in users.
function PublicHome() {
  const { token, loading } = useAuth();
  if (loading) return null;
  return token ? <Navigate to="/dashboard" replace /> : <Landing />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<PublicHome />} />
            <Route path="/kvkk" element={<Kvkk />} />
            <Route path="/sartlar" element={<Sartlar />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Navigate to="/login" replace />} />

            {/* Protected app */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/signals" element={<Signals />} />
                      <Route path="/scenario" element={<Scenario />} />
                      <Route path="/pairs" element={<Pairs />} />
                      <Route path="/positions" element={<Positions />} />
                      <Route path="/analytics" element={<Analytics />} />
                      <Route path="/strategy" element={<Strategy />} />
                      <Route path="/balance" element={<Balance />} />
                      <Route path="/ai" element={<AiAssistant />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/admin" element={<Admin />} />
                      <Route path="/vault" element={<Vault />} />
                      <Route path="/security" element={<SecurityCenter />} />
                      <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
